import React from "react";
import Img from "react-image";

class Thumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isQuer: false };
    this._onLoad = this._onLoad.bind(this);
  }

  _onLoad(e) {
    const thumbnailWidth = e.target.offsetWidth;
    const thumbnailHeight = e.target.offsetHeight;
    if (thumbnailWidth > thumbnailHeight) {
      this.setState({ isQuer: true });
    }
  }
  render() {
    const styleDiv = {
      height: "calc(100vh - 61px)",
      width: "100vw",
      position: "fixed",
      top: "63px",
      left: "0",
      overflow: "hidden",
      pointerEvents: "none",
      zIndex: "-4"
    };
    const style = {
      objectFit: "cover",
      height: "calc(100vh - 63px)",
      width: "100%"
    };
    const isQuer = this.state.isQuer;
    let thumbnail;

    if (isQuer) {
      thumbnail = (
        <Img
          className="thumbnail"
          src={this.props.src}
          style={style}
          onLoad={this._onLoad}
        />
      );
    } else {
      thumbnail = (
        <Img className="thumbnail" src={this.props.src} onLoad={this._onLoad} />
      );
    }
    return <div style={styleDiv}>{thumbnail}</div>;
  }
}
export default Thumbnail;



// WEBPACK FOOTER //
// /opt/build/repo/src/components/thumbnail.js